import { BsArrowRight } from "react-icons/bs";

const PortfolioItem = ({data, isRounded = false, width, height}) => {
    return (
        <div key={data.id} className={`group ${width} ${height} relative`}>
            <img
            src={data.thumb}
            alt={`${data.title}thumb`}
            className={`h-full object-cover ${isRounded && 'rounded'}`}
            />
            <div className={`w-full h-full absolute top-0 left-0 bg-primary opacity-0 group-hover:opacity-80 animation duration-500 flex justify-between items-end text-white px-5 pb-5 w-full ${isRounded && 'rounded'}`}>
            <div>
                <h4 className="text-xl font-medium text-left">{data.title}</h4>
                <p className="text-sm font-light text-left">{data.country}</p>
            </div>
            <a href={data.link} target="_blank" rel="noreferrer">
                <BsArrowRight size={34} />
            </a>
            </div>
        </div>
    )
}

export default PortfolioItem